import { action } from 'satcheljs/lib/legacy';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import ResponseTypeType from 'owa-service/lib/contract/ResponseTypeType';
import { MeetingRequestViewState } from '../store/schema/MeetingRequestViewState';
import { setResponseType } from '../mutators/setResponseType';
import { isDeepLink } from 'owa-popout';
import { respondToMeeting as respondToMeetingAction } from 'owa-meeting-message-actions';
import deleteMeetingMessage from './deleteMeetingMessage';

export default action('respondToMeetingRequest')(async function respondToMeeting(
    message: MeetingRequestMessageType,
    response: ResponseTypeType,
    sendResponse: boolean,
    viewState: MeetingRequestViewState,
    responseMessage?: string
) {
    deleteMeetingMessage(message);
    setResponseType(viewState, response);
    await respondToMeetingAction(
        message,
        response,
        sendResponse,
        'MailListMessage',
        responseMessage
    ).then(() => {
        if (isDeepLink() && window.opener) {
            window.close();
        }
    });
});
